import { gql } from "@apollo/client/core";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";

export interface AppVersionQueryResult {
  appVersion: string
}

export const GET_APP_VERSION: TypedDocumentNode<AppVersionQueryResult, Record<string, never>> = gql`
  query GetAppVersion {
    appVersion
  }
`;
